<div #table class="table-container">
  <table [ngClass]="{'no-data-table': bodyValues.length === 0}">
    <thead>
      <tr>
        <th>{{ headerLabel }}</th>

        <!-- Boucle sur les valeurs du header -->
        <th *ngFor="let headerValue of headerValues" class="th-value">{{ headerValue.label }}</th>
      </tr>
    </thead>

    <tbody *ngIf="bodyValues.length > 0">
      <!-- Boucle sur les labels du body -->
      <tr *ngFor="let value of bodyValues; let index = index" id="group_{{ index }}">
        <td class="td-label">{{ value.label }}</td>
        <td class="td-value" *ngFor="let headerValue of headerValues">
          <label>
            <input type="radio" [(ngModel)]="value.value" value="{{ headerValue.value }}" name="group_{{ index }}" [attr.disabled]="isDisabled(value, headerValue.value)">
          </label>
        </td>
      </tr>
    </tbody>
    <div class="no-data" *ngIf="bodyValues.length === 0 || !bodyValues">
      <p>Aucune information à afficher</p>
    </div>
  </table>
</div>
